import { render, staticRenderFns } from "./Popover4.vue?vue&type=template&id=7c64d267&"
import script from "./Popover4.vue?vue&type=script&lang=js&"
export * from "./Popover4.vue?vue&type=script&lang=js&"
import style0 from "./Popover4.vue?vue&type=style&index=0&id=7c64d267&prod&lang=scss&"
import style1 from "./Popover4.vue?vue&type=style&index=1&id=7c64d267&prod&lang=css&"
import style2 from "./Popover4.vue?vue&type=style&index=2&id=7c64d267&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports